import React, {Component, PropTypes} from 'react'
import spacing from 'material-ui/styles/spacing'
import {setConfig} from '../actions'

class TimelinePage extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  }
  componentWillMount() {
    this.context.store.dispatch(setConfig('title',null))
  }

  render() {
    const style = {
      paddingTop: spacing.desktopKeylineIncrement,
    }
    return (
      <div style={style}>
        <iframe src='https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1EH5aZdGoa5L1igx5S-JJnDkGip5b-j5hHEdFX16d8OA&font=Default&lang=en&initial_zoom=2&height=650'
          width='100%'
          height={window.innerHeight-spacing.desktopKeylineIncrement}
          frameborder='0'></iframe>
      </div>
    )
  }
}


export default TimelinePage



/** WEBPACK FOOTER **
 ** ./src/app/containers/TimelinePage.js
 **/